export default __webpack_public_path__ + "static/media/wormLoader.2aea11db.gif";